// extracted by mini-css-extract-plugin
export default {"row":"row__row-Nl894"};